import type {
  Contactpersoon,
  ContactpersoonAccount,
} from '../types/Contactpersoon'

export { isAccount, isAccountVerwijderd }

const isAccount = (
  contactpersoon: Contactpersoon,
): contactpersoon is ContactpersoonAccount => contactpersoon.type === 'account'

/** Een bestaand account heeft altijd een emailadres. */
const isAccountVerwijderd = (contactpersoon: Contactpersoon) =>
  isAccount(contactpersoon) && !contactpersoon.emailadres
